import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { deleteShortlist } from '@disco/state-management/actions/shortlist-upload-actions'
import { shortlistHasActiveUploads } from '@disco/state-management/selectors/shortlists'

import { getShortlistBaseRoute } from 'utils/routing'

import DocumentHeadTags from 'components/document-head-tags'
import ModalDialog from 'components/ui/modal-dialog'

import { useDispatch, useSelector } from 'hooks/use-redux'

const ShortlistsClear = () => {
  const params = useParams<{ shortlistId: string }>()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const activeUploads = useSelector(state =>
    shortlistHasActiveUploads(state, {
      id: params.shortlistId,
    }),
  )

  const onClose = () => {
    const baseRoute = getShortlistBaseRoute(location)
    const returnPath = baseRoute || '/'
    navigate(returnPath)
  }

  const handleItemsDelete = () => {
    dispatch(deleteShortlist(params.shortlistId!))
    onClose()
  }

  const renderMessage = () => {
    if (activeUploads) {
      return (
        <div>
          Are you sure you want to close this playlist?
          <br />
          Your work hasn’t been saved yet.
        </div>
      )
    } else {
      return (
        <div>
          Are you sure you want to close this playlist?
          <br />
          You’ll lose any unsaved changes.
        </div>
      )
    }
  }

  return (
    <div>
      <DocumentHeadTags title="Close playlist | DISCO" />
      <ModalDialog
        title="Close playlist"
        primaryAction={{
          caption: 'Close',
          onClick: handleItemsDelete,
        }}
        status="danger"
        onCancel={onClose}
      >
        {renderMessage()}
      </ModalDialog>
    </div>
  )
}

export default ShortlistsClear
